import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Clusters from '@/components/Clusters'
import Locations from '@/components/Locations'
import Indicators from '@/components/Indicators'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/clusters',
      name: 'clusters',
      component: Clusters,
    },
    {
      path: '/locations',
      name: 'locations',
      component: Locations,
      children: [
        {
          path: '/locations/indicators',
          name: 'indicators',
          component: Indicators
        },
        {
          path: '/locations/savedViews',
          name: 'savedViews',
          component: Locations,
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router.js